





























































































































































import { defineComponent, computed, ref, useContext, watch, useRoute, onMounted } from '@nuxtjs/composition-api'
import useI18n from '@/composables/use-i18n'
import useDefaultMeta from '@/composables/use-default-meta'
import useIsMounted from '@/composables/use-is-mounted'
import useBreakpoint from '@/composables/use-breakpoint'
import useSearchBar from '@/composables/use-search-bar'
import useSearchFilter from '@/composables/use-search-filter'
import useSearchList from '@/composables/use-search-list'
import useSearchMode, { SearchMode } from '@/composables/use-search-mode'
import useShowable from '@/composables/use-showable'
import useLog from '@/composables/use-log'

import { parseActiveStore, parseSearchMode, parseSearchUrlQuery as parseQuery } from '@/modules/route-query'
import { isDuringHoliday } from '@/modules/holiday'

import SearchFilter from '@/classes/SearchFilter'

import SearchBar from '@/components/search-bar/SearchBar.vue'
import FilterDialog from '@/components/filter/FilterDialog.vue'
import ggoApi from '@/modules/ggo-api'

import useSearchLogger from '@/composables/use-search-logger'
import useSeats from '@/composables/use-seats'
import { isString } from 'typechecker'
import ggoLogger from '@/modules/ggo-logger'
import { LogName } from '@/interfaces/Logger'
import gbClient from '@/modules/growthbook/gb-client'
import CarStore from '@/classes/CarStore'
import { FeatureFlagKey } from '@/modules/growthbook/feature-flag'

const { stringify } = JSON

export default defineComponent({
  head: {},
  scrollToTop: false,
  name: 'Search',
  setup () {
    const i18n = useI18n()
    const { query } = useContext()

    const isShowPopup = ref(false)

    const setPopup = () => {
      isShowPopup.value = true
    }

    const refresh = () => {
      isShowPopup.value = false
      window.location.reload()
    }

    useDefaultMeta({
      title: String(i18n.t('SEO.search.title')),
      description: String(i18n.t('SEO.search.metaDescription')),
    })

    const isMounted = useIsMounted()
    const route = useRoute()
    const Chinese = route.value.path.includes('zh-tw')

    const searchBar = ref<InstanceType<typeof SearchBar> | null>(null)
    const showLocationPicker = () => searchBar.value?.showLocationPicker('rent')
    const showDatePicker = () => searchBar.value?.showDatePicker()

    const {
      isShow: isSearchBarFoldableShow,
      show: showSearchBarFoldable,
      hide: hideSearchBarFoldable,
    } = useShowable()

    const {
      location,
      locationReturn,
      dateHourRange,
      seats,
      queryObject,
      setValueFromQuery,
      saveLocation,
      pushQuery,
      isStartDateMoreThan,
    } = useSearchBar()

    /**
     * 送出表單。
     * 實際做的只有將目前表單 push 至網址參數，而 watcher 見網址參數改變便會自動執行搜尋。
     */
    const submit = () => {
      hideSearchBarFoldable()
      pushQuery(queryObject.value)
      saveLocation()
    }

    const {
      filter,
      sortMethod,
      normalizePriceRange,
      setSearchFilterFromQuery,
      clear: clearFilter,
    } = useSearchFilter()
    const { list: seatList } = useSeats()
    watch(queryObject, (val) => {
      if (val.seats) {
        const seat = seatList.find(item => item.value === val.seats)
        if (seat) {
          filter.value.setSeatMin(seat.min)
          filter.value.setSeatMax(seat.max)
        }
      }
    })

    onMounted(() => {
      pushQuery(query.value)
    })

    onMounted(() => {
      // 網址參數 → filter
      watch(() => stringify(SearchFilter.fromQueryObject(query.value).queryObject), () => {
        setSearchFilterFromQuery(query)
      }, { immediate: true })
    })
    // filter → 網址參數
    watch(filter, (filter) => {
      pushQuery(filter.queryObject)
      window.scrollTo(0, 0)
    })

    onMounted(() => {
      // 網址參數 → 表單值
      watch(() => stringify(parseQuery(query.value)), () => {
        setValueFromQuery(query, { fallbackDateHourRange: true })
        runSearchOrFuzzySearch()
      }, { immediate: true })
    })
    onMounted(() => {
      window.addEventListener('load', function () { // TODO: 之後希望能把這個邏輯抽離成common module
        if (!sessionStorage.getItem('reload')) { sessionStorage.setItem('reload', '0') }/// /若搜尋出0台車時且原本沒有sess reload 次數紀錄reload 次數為0
        const reloadnum = Number(sessionStorage.getItem('reload'))
        if (count.value === 0) { sessionStorage.setItem('reload', String(reloadnum + 1)) }
        if (count.value === 0 && reloadnum + 1 > 0) { // 由於onload 會同時被first load 及後續reload triggered 因此紀錄 load 次數若為0，則為first load 不需 log reload
          ggoLogger.info(LogName.SEARCH_ZERO,
            {
              message: 'page-reload',
            }
          )
        }
      })
      window.addEventListener('beforeunload', () => {
        if (count.value === 0) {
          ggoLogger.info(LogName.SEARCH_ZERO,
            {
              message: 'page-closed-or-reload', // event 會被reload&close triggered 因此 後面搜集log的要減法
            }
          )
        }
      })
    })

    const {
      qid,
      rankerName,
      storeCarsList,
      isFuzzySearch,
      filteredStoreCarsList,
      displayedCarStoreList,
      setStoreCarsListFromApi,
      activeStoreId,
      setActiveStoreIdFromQuery,
      carStoreList,
      filteredCarStoreList,
      count,
      priceRangeMinMax,
      brandIds,
      carTypeIds,
      stateMessage,
    } = useSearchList(filter, location, dateHourRange)

    watch(priceRangeMinMax, (value) => {
      if (value) normalizePriceRange(value)
    }, { immediate: true })

    onMounted(() => {
      // activeStoreId → 網址參數
      watch(() => parseActiveStore(query.value), () => {
        setActiveStoreIdFromQuery(query.value)
      }, { immediate: true })
      // 網址參數 → activeStoreId
      watch(activeStoreId, (id) => {
        return pushQuery({
          activeStore: id ? String(id) : undefined,
        })
      })
    })

    const {
      isShow: isLocationsSectionShow,
      show: showLocationsSection,
      hide: hideLocationsSection,
    } = useShowable()

    const noCarHint = ref <object | null>(null)
    const noCarHintMessage = ref <string | null>(null)

    const noCarErrorHint = (errorMessage: object | null) => {
      if (errorMessage) {
        const { holidayType = 'spring_festival', maxDay = 0, minDay = 0 } = { ...errorMessage }
        let inputType: String
        holidayType === 'spring_festival' ? inputType = String(i18n.t('message.noCarHintNewYear')) : inputType = String(i18n.t('message.noCarHintCont'))
        Chinese
          ? noCarHintMessage.value = `${inputType}${String(i18n.t('message.noCarHint', [minDay, maxDay]))}`
          : noCarHintMessage.value = `${String(i18n.t('message.noCarHintEnglish', [inputType, minDay, maxDay]))}`
      } else if (isStartDateMoreThan(365, 'day')) { // 若搜尋起始時間為今天的365天後，顯示不同文字
        noCarHintMessage.value = String(i18n.t('message.noResultMoreThanAvailableTime'))
      } else {
        noCarHintMessage.value = String(i18n.t('message.noResult'))
      }
    }

    /** 執行一般搜尋和模糊搜尋並顯示提示訊息 */
    const runSearchOrFuzzySearch = async () => {
      hideLocationsSection()
      // 若地點和日期區間皆合法
      if (isLocationValid.value && isRangeValid.value) {
        await search()

        // 當列表為空時
        if (carStoreList.value && !carStoreList.value.length) {
          // 若所選擇的日期區間逢連假
          if (isDuringHoliday(dateHourRange.value)) {
            stateMessage.value = {
              icon: 'sad-magnifier',
              message: String(i18n.t('message.noResultDueToHoliday')),
            }
          } else { // 預設情況（未知或沒有理由）
            stateMessage.value = {
              icon: 'sad-magnifier',
              message: noCarHintMessage.value ?? '',
            }
          }
        }
      } else if (isLocationValid.value) { // 若地點合法但日期不合法或未選
        stateMessage.value = {
          icon: 'no-date',
          message: String(i18n.t('message.noDateHourRange')),
        }
        await fuzzySearch()
      } else { // 若地點和日期區間皆不合法
        stateMessage.value = {
          icon: 'no-location',
          message: String(i18n.t('message.noLocationAndDateHourRange')),
        }
        showLocationsSection()
      }

      window.scrollTo(0, 0)
    }

    const { addSearchLog, clickCar } = useLog()

    /** 一般搜尋 */
    const search = async () => {
      storeCarsList.value = null
      storeCarsList.error = null
      storeCarsList.isFetching = true

      try {
        await addSearchLog(async () => {
          const params = queryObject.value
          const { success, data, error } = await ggoApi.searchCars(params)
          if (!success || !data) {
            throw new Error(error ?? '')
          } else {
            if (data.data.length === 0) {
              noCarErrorHint(data.meta)
            }
            // TODO: 把推薦系統的東西整理一下
            qid.value = data.qid
            rankerName.value = data.rankerName
            gbClient.experimentMap = {
              ...gbClient.experimentMap,
              ...(Object.fromEntries((data.experiments ?? []).map(exp => [exp.key, exp.value]))),
            }
            setStoreCarsListFromApi(data.data)
            if (count.value === 0) {
              if (!sessionStorage.getItem('reload')) { sessionStorage.setItem('reload', '0') }// 若搜尋出0台車時且原本沒有sess reload 次數紀錄reload 次數為0
              ggoLogger.info(LogName.SEARCH_ZERO,
                {
                  message: 'no-car',
                }
              )
            } else {
              sessionStorage.removeItem('reload') // 搜出非0時要刪掉
            }
            return count.value
          }
        })
      } catch (e: any) {
        storeCarsList.error = isString(e) ? e : JSON.stringify({ error: e })
        ggoLogger.info(LogName.TOAST, {
          type: 'danger',
          message: JSON.stringify({ error: e }),
        })
      }
      storeCarsList.isFetching = false
    }

    /** 模糊搜尋。亦即所謂「隨機找六台車」 */
    const fuzzySearch = async () => {
      storeCarsList.value = null

      try {
        const params = {
          ...queryObject.value,
          brand: filter.value.brands.map(String),
          carType: filter.value.carTypes.map(String),
        }
        const { success, data, error } = await ggoApi.searchFuzzyCars(params)

        if (!success || !data) throw new Error(error ?? '')

        if (data.length === 0) {
          noCarErrorHint(data)
        }
        setStoreCarsListFromApi(data)
      } catch (e) {
        /** 忽略模糊搜尋的錯誤 */
      }
    }

    const { match } = useBreakpoint()
    const isMobile = computed(() => !match('xl'))

    const filterDialog = ref<InstanceType<typeof FilterDialog> | null>(null)
    /** 顯示 mobile 的篩選條件視窗 */
    const showFilterDialog = () => filterDialog.value?.show()

    const { modes, mode, modeQueryObject, setModeFromQuery } = useSearchMode()
    const setMode = (value: SearchMode) => {
      mode.value = value
    }
    onMounted(() => {
      // 網址參數 → mode
      watch(() => parseSearchMode(query.value, modes), () => {
        setModeFromQuery(query)
      }, { immediate: true })
      // mode → 網址參數
      watch(mode, () => {
        pushQuery(modeQueryObject.value)
        window.scrollTo(0, 0)
      })
    })

    const isLocationValid = computed(() => Boolean(location.value))
    const isRangeValid = computed(() => dateHourRange.value.isValid)

    /** 是否顯示全螢幕的地圖 */
    const isFullscreenMapShow = computed(() => [
      isMobile.value,
      mode.value === 'map',
      isLocationValid.value,
      isRangeValid.value,
    ].every(Boolean))

    /** 使用者所搜尋的地點座標 */
    const origin = computed(() => location.value?.coordinate)

    // 進入此頁面時，地點或日期時間不合法時展開選單
    onMounted(async () => {
      await new Promise(resolve => setTimeout(resolve, 500))

      const { value: bar } = searchBar

      if (!isMobile.value) {
        if (!bar?.isLocationValid) showLocationPicker()
        else if (!bar?.isRangeValid) showDatePicker()
      } else if (!(bar?.isLocationValid && bar?.isRangeValid)) {
        showSearchBarFoldable()
      }
    })

    /** 點擊車輛卡牌的「選擇日期」按鈕 */
    const clickCardCarPickDate = () => {
      showSearchBarFoldable()
      showDatePicker()
    }

    const { searchLog } = useSearchLogger()
    /** filteredCarStoreList 經「排序」和「篩選」過的列表 */
    watch(filteredCarStoreList, (val) => {
      searchLog({
        search: queryObject.value,
        filter: filter.value,
        storeCnt: storeCarsList.value?.length ?? 0,
        vehicleCnt: val?.length ?? 0,
        qid: qid.value,
      })
    })

    const hoveredStoreId = ref<number>()
    const onCarCardHover = (value?: CarStore) => {
      hoveredStoreId.value = value?.store?.id
    }

    /** FIXME: ab-testing-84836353 */
    const { store } = useContext()
    onMounted(() => {
      watch(() => store?.state.growthbook.flags[FeatureFlagKey.BETA_RANKER], (val) => {
        if (val) {
          sortMethod.value = 'rankDesc'
        }
      }, { immediate: true })
    })

    return {
      isMounted,
      Chinese,

      isShowPopup,
      setPopup,
      refresh,

      noCarHint,
      searchBar,
      showLocationPicker,
      showDatePicker,
      isSearchBarFoldableShow,
      showSearchBarFoldable,
      storeCarsList,
      isFuzzySearch,
      filteredStoreCarsList,
      displayedCarStoreList,
      carStoreList,
      filteredCarStoreList,
      count,
      priceRangeMinMax,
      brandIds,
      carTypeIds,

      isLocationValid,
      isRangeValid,
      location,
      locationReturn,
      dateHourRange,
      seats,

      submit,

      isMobile,
      filterDialog,
      showFilterDialog,

      filter,
      clearFilter,
      sortMethod,

      mode,
      setMode,
      modes,

      isFullscreenMapShow,
      origin,

      activeStoreId,
      clickCardCarPickDate,

      stateMessage,
      isLocationsSectionShow,

      clickCar,

      qid,
      rankerName,

      hoveredStoreId,
      onCarCardHover,
    }
  },
})
